import { RESTSerializer } from '@warp-drive/legacy/serializer/rest';

export default class Set extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return modelName.replace(/^school-options\/set/, 'optionSet');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(
      key.replace(/^optionSet/, 'school-options/set'),
    );
  }
}
